import { gql } from '@apollo/client';
import CLINIC_DEVICES_FRAGMENT from '../fragments/clinicDevices';

const CLINIC_DEVICES_QUERY = gql`
  query clinicDevices($filter: CallCenterDeviceFilterInput, $limit: Int) {
    callCenterDevices(filter: $filter, limit: $limit) {
      ...ClinicDeviceFragment
    }
  }

  ${CLINIC_DEVICES_FRAGMENT}
`;

export default CLINIC_DEVICES_QUERY;
